module.exports = __webpack_public_path__ + "assets/img/b51c-cl.svg";